<template>
    <div class="registry-wrapper">
        <container-loader v-if="isLoading && !$store.getters.isLoading" />
        <div class="columns">
            <div
                class="column"
                :class="[
                    permissaoVincular && permissaoCadastrar
                        ? 'is-4'
                        : permissaoVincular || permissaoCadastrar
                        ? 'is-6'
                        : 'is-8',
                ]"
            >
                <search-bar
                    :onSearch="debouncedOnSearch"
                    tooltipLabel="msg-campo-busca-fornecedor-restricao"
                />
            </div>
            <div
                class="column"
                :class="[
                    permissaoVincular && permissaoCadastrar
                        ? 'is-2'
                        : permissaoVincular || permissaoCadastrar
                        ? 'is-3'
                        : 'is-4',
                ]"
            >
                <vss-select
                    ref="situacaoSelect"
                    :searchable="false"
                    :options="situacaoSelect"
                    v-model="situacaoSelected"
                    mlLabels
                    title="situacao"
                    clearable
                    @input="onSituacaoChanged"
                    :height="40"
                />
            </div>

            <div class="column is-3" v-if="permissaoVincular">
                <button class="save-btn botao-acao" type="button" @click="showModal = !showModal">
                    {{ $t('vincular-fornecedor') }}
                </button>
            </div>

            <div class="column is-3" v-if="permissaoCadastrar">
                <button
                    class="save-btn botao-acao"
                    type="button"
                    @click="
                        $router.push({
                            name: `${abrev}-fornecedor-new`,
                            query: {
                                tela: 'cliente-fornecedor',
                                id: $route.params.id,
                                dadoscadastrais: $route.query.dadoscadastrais
                                    ? $route.query.dadoscadastrais
                                    : null,
                                politicacomercial: 9,
                                analisecomercial: $route.query.analisecomercial
                                    ? $route.query.analisecomercial
                                    : null,
                                contexto: isVenda ? 'ven' : 'agro',
                            },
                        })
                    "
                >
                    {{ $t('adicionar-fornecedor') }}
                </button>
            </div>
        </div>
        <div class="registry-wrapper">
            <empty-table-message v-if="isEmpty" />
            <b-table
                v-else
                :data="fornecedorrestricaolist"
                class="data-table"
                @sort="sortTable"
                backend-sorting
            >
                <b-table-column
                    v-for="(f, i) in fields"
                    :key="i"
                    :field="f.key"
                    :label="f.key != 'excluir' ? $t(f.key) : ''"
                    :width="f.width"
                    :class="{
                        'excluir-field': f.key == 'excluir',
                    }"
                    :sortable="f.sortable"
                    :custom-sort="f.sortFn"
                    v-slot="props"
                >
                    <div v-if="f.key == 'excluir'">
                        <b-button
                            v-if="permissao.update && !assFornecedorRestricaoClienteIntegracao"
                            class="action-button"
                            :type="props.row['replicapda'] == 3 ? 'is-danger' : 'is-success'"
                            :icon-right="props.row['replicapda'] == 3 ? 'delete' : 'check'"
                            @click="promptChangeSituacao(props.row)"
                            v-tippy
                            :title="$t(props.row['replicapda'] == 3 ? 'desativar' : 'reativar')"
                        />
                    </div>

                    <div v-else-if="f.key == 'data-hora'">
                        {{ props.row[f.key] | moment('DD/MM/YYYY HH:mm:ss') }}
                    </div>
                    <div v-else-if="f.key == 'replicapda'">
                        <b-tag
                            class="table-tag table-tag-full-width"
                            :type="props.row['replicapda'] == 3 ? 'is-success' : 'is-danger'"
                            size="is-medium"
                        >
                            {{ $t(props.row['replicapda'] == 3 ? 'ativo' : 'inativo') }}
                        </b-tag>
                    </div>
                    <div v-else>
                        {{ props.row[f.key] }}
                    </div>
                </b-table-column>
            </b-table>
            <PaginationViewer
                class="mb-0"
                :resetPagination="pagination.resetPagination"
                :totalItems="pagination.totalRows"
                :perPageOptions="pagination.perPageOptions"
                :optionStarted="pagination.optionStarted"
                @change="updatePagination"
            />
        </div>
        <!-- MODAL DE ASSOCIACAO -->
        <b-modal :active.sync="showModal" @fecharModal="fecharModal">
            <div class="bg">
                <FornecedorRestricaoSelectModal
                    :idcliente="$route.params.id"
                    @fecharModal="fecharModal"
                    @selected="selected"
                    v-if="modalManage == false"
                />
            </div>
        </b-modal>
    </div>
</template>

<script>

// SERVICES
import AssFornecedorRestricaoCliente from '@/services/vendas/cliente/abas/AssFornecedorRestricaoClienteService';
import FornecedorRestricaoSelectModal from '@/components/vendas/cliente/modal/FornecedorRestricaoSelectModal.vue';
// COMPONENTS
import ContainerLoader from '@/components/content/loader/ContainerLoader';

export default {
    props: {
        data: {
            type: Object,
            default: () => {},
        },
    },
    components: {
        ContainerLoader,
        FornecedorRestricaoSelectModal,
    },
    data() {
        return {
            assFornecedorRestricaoClienteIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'FORNECEDORRESTRICAO'
            ),
            fornecedorRestricaoIntegracao: this.$store.state.user.tabelasERPWebServer.includes(
                'FORNECEDOR'
            ),
            fornecedorrestricaolist: [],
            fields: [
                { key: 'codigo', width: null, sortable: true, sortFn: null },
                { key: 'nome', width: null, sortable: true, sortFn: null },
                { key: 'rsocial', width: null, sortable: true, sortFn: null },
                { key: 'replicapda', width: 80, sortable: true, sortFn: null },
                { key: 'excluir', width: 20, sortable: false, sortFn: null },
            ],

            service: new AssFornecedorRestricaoCliente(this.$http, this.$router),
            permissao: false,
            permissaoUsuario: false,
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            situacaoSelected: { id: 4, label: 'todos' },
            situacaoSelect: [
                { id: 4, label: 'todos' },
                { id: 3, label: 'ativos' },
                { id: 2, label: 'inativos' },
            ],
            isLoading: false,
            isEmpty: false,
            debouncedOnSearch: null,
            queryFilter: '',
            column: 'nome',
            order: 'asc',
            isSaving: false,
            delete: null,
            showModal: false,
            modalCadastroFornecedorRestricao: false,
            modalManage: false,
            fornecedorRestricao: null,
            //permissoes relativas à exibição dos botões
            permissaoVincular: false,
            permissaoCadastrar: false,

            // @86308 - Rota dinâmica abreviando o contexto
            abrev: this.$route.meta.contexto.slice(0, 3),
            isVenda: this.$route.meta.contexto == 'vendas',
            isAgro: this.$route.meta.contexto == 'agro',
        };
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];

        if (this.isVenda) {
            this.permissao = this.hasPermissionAccess(
                'vendas',
                'clientes',
                'ven-cliente-politica-comercial-fornecedor-restricao'
            );
        } else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissao = this.hasPermissionAccess(
                'agro',
                'clientes',
                'agro-cliente-politica-comercial-fornecedor-restricao'
            );
        }

        if (this.isVenda) {
            this.permissaoCadastroFornecedorRestricao = this.hasPermissionAccess(
                'vendas',
                'clientes',
                'ven-fornecedor'
            );
        } else if (this.isAgro) {
            this.abrev = this.$route.meta.contexto.slice(0, 4);
            this.permissaoCadastroFornecedorRestricao = this.hasPermissionAccess(
                'agro',
                'clientes',
                'agro-fornecedor'
            );
        }

        this.permissaoVincular =
            this.permissao.create && !this.assFornecedorRestricaoClienteIntegracao;
        this.permissaoCadastrar =
            this.permissaoCadastroFornecedorRestricao.create && !this.fornecedorRestricaoIntegracao;

        if (!this.permissao.read) {
            this.$router.push({
                name: 'acesso-nao-permitido',
                params: { tela: 'clientes' },
            });
        } else {
            this.carregarDados();
            this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        }
    },
    methods: {
        showMessage(type, message) {
            let data = {
                type: type,
                message: message,
            };

            this.$emit('alert', data);
        },
        loadPage(pageNumber) {
            let query = {
                page: pageNumber,
                limit: this.data.perPage,
                column: this.column,
                order: this.order,
            };

            this.$emit('load-page', query);
        },
        loadSort(field, order) {
            this.column = field;
            this.order = order;

            this.loadPage(this.data.page);
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;

            this.isLoading = true;

            this.findAll(
                this.column,
                this.order,
                currentPage - 1,
                this.pagination.perPage,
                this.situacaoSelected.id,
                this.$route.params.id,
                this.queryFilter
            )
                .then(this.mapItems)
                .then((value) => {
                    this.fornecedorrestricaolist = value;
                    this.isEmpty = this.fornecedorrestricaolist.length <= 0;
                })
                .catch((e) => {
                    this.isEmpty = true;
                    this.$root.showMessage('error', 'msg-erro-load');
                    console.error('Erro-carregar-fornecedor-restricao');
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        findAll(column, order, page, limit, situacao, idcliente, ...params) {
            if (this.isVenda) {
                return this.service.findAllVendas(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idcliente,
                    ...params
                );
            } else {
                return this.service.findAllAgro(
                    column,
                    order,
                    page,
                    limit,
                    situacao,
                    idcliente,
                    ...params
                );
            }
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;
            return body.content.map((m) => {
                return {
                    idfornecedorrestricao: m.idfornecedorrestricao,
                    codigo: m.fornecedor.idfornecedorerp,
                    idfornecedor: m.fornecedor.idfornecedor,
                    nome: m.fornecedor.nome,
                    rsocial: m.fornecedor.rsocial,
                    'data-hora': m.datahorainc,
                    replicapda: m.replicapda,
                };
            });
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados(this.pagination.currentPage);
        },
        onSituacaoChanged(val) {
            this.situacaoSelected = val
                ? this.situacaoSelect.filter((v) => v.id == val.id)[0]
                : this.situacaoSelect[0];
            this.carregarDados();
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarDados();
        },
        promptChangeSituacao(row) {
            this.delete = row;
            let message = this.$t(
                    row.replicapda == 3
                        ? 'msg-confirmacao-desativacao-n'
                        : 'msg-confirmacao-reativacao-n', 
                    { n: row['nome'] }
                );
            this.$root.confirm({
                message: message,
                onConfirm: this.updateSituacaoRegistro,
                onCancel: this.removePrompt,
            });
        },
        removePrompt() {
            this.delete = null;
        },
        updateSituacaoRegistro() {
            let tempFailure =
                this.delete.replicapda == 3
                    ? 'msg-erro-ao-reativar-associacao-fornecedor-restricao'
                    : 'msg-erro-ao-desativar-associacao-fornecedor-restricao';

            let tempfornecedorrestricao = {
                idfornecedorrestricao: this.delete.idfornecedorrestricao,
                replicapda: this.delete.replicapda == 3 ? 2 : 3,
            };

            this.isLoading = true;

            this.updateSituacao(tempfornecedorrestricao)
                .then((r) => {
                    if (r.status == 200) {
                        let tempSuccess =
                            r.content.replicapda == 3
                                ? 'msg-sucesso-ao-reativar-associacao-fornecedor-restricao'
                                : 'msg-sucesso-ao-desativar-associacao-fornecedor-restricao';
                        this.$root.showMessage('success', tempSuccess);
                        this.carregarDados(this.pagination.currentPage);
                    } else if (r.status == 500) {
                        this.$root.showMessage('error', 'Erro ao atualizar status.');
                    }
                })
                .catch((e) => {
                    console.error('Erro ao atualizar status.', e);
                    this.$root.showMessage('error', tempFailure);
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.delete = null;
                });
        },
        updateSituacao(fornecedorrestricao) {
            if (this.isVenda) return this.service.updateSituacaoVendas(fornecedorrestricao);
            else return this.service.updateSituacaoAgro(fornecedorrestricao);
        },
        showModalFornecedorRestricaoNaoAsoociados() {
            this.showModalAssociacao = !this.showModalAssociacao;
        },
        showModalCadastroFornecedorRestricao() {
            this.modalCadastroFornecedorRestricao = !this.modalCadastroFornecedorRestricao;
        },
        fecharModal() {
            this.showModal = false;
            this.modalManage = false;
            this.modalCadastroFornecedorRestricao = false;
            this.carregarDados();
        },
        selected(selected) {
            this.modalManage = true;
            this.fornecedorrestricao = selected;
        },
        selectedEdit(selected) {
            this.modalManage = true;
            this.fornecedorrestricao = selected;
            this.showModal = true;
        },
        cadastrado() {
            this.modalCadastroFornecedorRestricao = false;
            this.carregarDados();
        },
    },
};
</script>
<style lang="scss" scoped>
.botao-acao {
    margin-top: 24px;
    width: 100%;
    height: 40px;
}

@media (max-width: 760px) {
    .search-bar {
        padding-bottom: 0.4rem;
    }
    .botao-acao {
        margin-top: 0;
    }
}
</style>
